import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const InputValidIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M10 16.94 20.97 5.967l1.06 1.06L10 19.062l-7.03-7.032 1.06-1.06 5.97 5.97Z" />
  </IconWrapper>
)

export default InputValidIconMedium
